"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThemeManager = exports.ThemeProvider = exports.ThemeContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const style_1 = __importDefault(require("style"));
const action_1 = require("./action");
const state_1 = require("./state");
const constant_1 = require("./constant");
const reducer_1 = require("./reducer");
__exportStar(require("./constant"), exports);
exports.ThemeContext = react_1.default.createContext(state_1.InitialState);
function optimizeThemes({ secondary, primary }) {
    function adjustFonts() {
        return {
            Primary: primary,
            Secondary: secondary,
            Fallback: 'sans-serif',
        };
    }
    const lens = R.lensPath(['Text', 'Family']);
    const light = R.over(lens, adjustFonts, style_1.default.Theme.Light);
    const dark = R.over(lens, adjustFonts, style_1.default.Theme.Dark);
    return { light, dark };
}
const ThemeProvider = ({ children }) => {
    const [state, dispatch] = react_1.default.useReducer(reducer_1.reducer, state_1.InitialState);
    return ((0, jsx_runtime_1.jsx)(exports.ThemeContext.Provider, Object.assign({ value: { state, dispatch } }, { children: children })));
};
exports.ThemeProvider = ThemeProvider;
function useThemeManager(props) {
    const { state, dispatch } = react_1.default.useContext(exports.ThemeContext);
    console.log(state);
    const setTheme = react_1.default.useCallback((type) => {
        dispatch({ type: action_1.ActionType.SetTheme, payload: type });
    }, [dispatch]);
    const themes = react_1.default.useMemo(() => {
        return optimizeThemes(props);
    }, [props]);
    const theme = react_1.default.useMemo(() => {
        return state.type === constant_1.ThemeType.Light
            ? themes.light
            : themes.dark;
    }, [state.type, themes]);
    return {
        setTheme,
        theme,
        type: state.type,
    };
}
exports.useThemeManager = useThemeManager;
